import React from "react";
import SupportersListSkeleton from "./SupportersListSkeleton";
import { SkeletonBlock, SkeletonProgress, SkeletonStatus } from "../Components/skeleton/SkeletonPieces";

/**
 * NonFormSkeleton - Loading skeletons for non-form elements
 *
 * Provides consistent loading states for:
 * - FUNDRAISING_BAR: the track and the stat row, at the bar's own size
 * - SUPPORTERS_LIST: the list's own card (SupportersListSkeleton)
 * - DONATION_FLAG: the flag's own box
 *
 * Each frame sits where its element paints — at the element's top-left with
 * no padding of its own — so nothing moves when the element replaces it. The
 * blocks are the shared skeleton pieces (Components/skeleton/).
 *
 * Note: Form-type skeletons (STANDARD_FORM, EVENT, PRODUCT, etc.)
 * are handled by FormSkeleton.jsx
 */
// Skeleton blocks are the sunken neutral at the skeleton radius (CON-517);
// callers still pass brandColors / primaryColor, which no longer paint.
const NonFormSkeleton = ({
  elementType = "FUNDRAISING_BAR",
}) => {
  // The donor list's placeholder is the list's own shape, full width with no
  // padding. See SupportersListSkeleton.
  if (elementType === "SUPPORTERS_LIST" || elementType === "DONOR_LIST") {
    return <SupportersListSkeleton />;
  }

  if (elementType === "DONATION_FLAG") {
    return (
      <SkeletonStatus label="Loading donation flag">
        {/* The flag's own box (G73-0): 40 tall, control radius. */}
        <SkeletonBlock shape="control" className="h-10 w-28" />
      </SkeletonStatus>
    );
  }

  return (
    <SkeletonStatus label="Loading fundraising progress" className="w-full">
      {/* FKO-0: the 6px track, then the stat row. */}
      <SkeletonProgress />
    </SkeletonStatus>
  );
};

export default NonFormSkeleton;
